<span class="dropdown h-100 m-auto" dropdown #dropdown="bs-dropdown" [dropup]="false">
  <a data-toggle="dropdown" dropdownToggle (click)="false" class="me-2">
    <app-svg-icon type="filter" size="small" class="mx-1" [inline]="true"/>
  </a>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-left">
    <li>
      <a class="dropdown-item d-flex align-items-center" (click)="changeActiveFilter(null)">
        <app-svg-icon type="close" size="small" class="me-2"/>
        <span [innerHTML]="'projectVersionHistoryPopup.filter.reset' | translate"></span>
      </a>
    </li>
    @for ( filter of historyFilter; track $index) {
      <li>
        <div class="form-check ms-2 c-pointer" (click)="changeActiveFilter(filter.version)">
          <input class="form-check-input" type="radio" [value]="false" [checked]="filter.active">
          <label class="form-check-label">{{filter.version}}</label>
        </div>
      </li>
    }
  </ul>
</span>
